import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { StatusBadge } from "@/lib/format";
import { PageHeader, TableShell, StatusSelect } from "@/components/admin/ui";

const STATUSES = ["Agendado", "Em Andamento", "Concluído"];

export default function OrdersPage() {
  const [orders, setOrders] = useState(null);

  const load = () => api.get("/orders").then((r) => setOrders(r.data)).catch(() => setOrders([]));
  useEffect(() => {
    load();
  }, []);

  const setStatus = async (order, status) => {
    try {
      await api.patch(`/orders/${order.id}`, { status });
      toast.success(`${order.number} → ${status}`);
      load();
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  if (!orders) {
    return (
      <div className="flex h-64 items-center justify-center">
        <Loader2 size={28} className="animate-spin text-[#FFB800]" />
      </div>
    );
  }

  return (
    <div data-testid="orders-page">
      <PageHeader title="Ordens de Serviço" sub={`${orders.length} ordens registradas`} testId="orders-header" />
      <TableShell head={["Número", "Cliente", "Serviço", "Status", "Data"]} testId="orders-table">
        {orders.map((o, i) => (
          <tr key={o.id} className="text-zinc-300 transition-colors hover:bg-white/[0.02]" data-testid={`order-table-row-${i}`}>
            <td className="px-5 py-4 font-semibold text-white">#{o.number}</td>
            <td className="px-5 py-4">{o.client}</td>
            <td className="px-5 py-4">{o.service}</td>
            <td className="px-5 py-4">
              <div className="flex items-center gap-2">
                <StatusBadge status={o.status} />
                <StatusSelect value={o.status} options={STATUSES} onChange={(s) => setStatus(o, s)} testId={`order-status-select-${i}`} />
              </div>
            </td>
            <td className="px-5 py-4 text-zinc-500">{o.date}</td>
          </tr>
        ))}
      </TableShell>
    </div>
  );
}
